
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Report {
  title: string;
  date: string;
  consumption: number;
  status: string;
}

export interface ReportCardProps {
  reports: Report[];
  reportStatusColors: Record<string, string>;
}

const ReportCard: React.FC<ReportCardProps> = ({ reports, reportStatusColors }) => {
  return (
    <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-xl font-bold text-gray-900 dark:text-white">Recent Energy Reports</CardTitle>
        <FileText className="h-4 w-4 text-gray-500 dark:text-gray-400" />
      </CardHeader>
      <CardContent>
        <div className="space-y-4 max-h-[420px] overflow-y-auto">
          {reports.map((report, index) => (
            <div key={index} className="flex items-center p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
              <div className={`w-2 h-2 rounded-full mr-3 ${reportStatusColors[report.status]}`}></div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200">{report.title}</h4>
                <p className="text-xs text-gray-500 dark:text-gray-400">{report.date}</p>
              </div>
              <span className="text-xs font-medium text-gray-600 dark:text-gray-400">{report.consumption} kWh</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ReportCard;
